"use strict";require("core-js/modules/es.array.includes");require("core-js/modules/es.date.to-string");require("core-js/modules/es.number.constructor");require("core-js/modules/es.number.is-nan");require("core-js/modules/es.object.to-string");require("core-js/modules/es.parse-float");require("core-js/modules/es.parse-int");require("core-js/modules/es.regexp.exec");require("core-js/modules/es.regexp.to-string");require("core-js/modules/es.string.includes");require("core-js/modules/es.string.replace");require("core-js/modules/es.string.split");exports.__esModule = true;exports.castNum = castNum;exports.randNum = randNum;exports.roundNum = roundNum;exports.ceilNum = ceilNum;exports.floorNum = floorNum;exports.shortenNum = shortenNum;exports.getDigitLevel = getDigitLevel;exports.splitNumByClasses = splitNumByClasses;exports.MAX_SAFE_INTEGER = void 0;

var _is = require("./is");


/**
                            * @namespace __Number
                            */



/**
                                * Максимально допустимое число
                                *
                                * @type {number}
                                * @memberof __Number
                                */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
                                          * Возвращает первый аргумент если это число, иначе второй, если задан, либо - 0
                                          *
                                          *
                                          * @param {*} maybeNum
                                          * @param {number} [def] опционально
                                          * @example
                                          * castNum( 3 ) // 3
                                          * castNum( undefined ) // 0
                                          * castNum( undefined, 11 ) // 11
                                          * @returns {number}
                                          * @memberof __Number
                                          */exports.MAX_SAFE_INTEGER = MAX_SAFE_INTEGER;
function castNum(
maybeNum,
def)
{
  var n = maybeNum;
  if ((0, _is.isStr)(n)) {
    var hasDorOrComma = n.includes('.') || n.includes(',');
    n = hasDorOrComma ? parseFloat(n) : parseInt(n, 10);
  }
  if ((0, _is.isNum)(n)) return n;
  return (0, _is.isNum)(def) ? def : 0;
}


/**
   * Возвращает рандомное число в указаннном промежутке, либо если не указан - от 0 до 9007199254740991
   *
   *
   * @param {?number} minNum *
   * @param {?number} maxNum *
   * @example
   * randNum() // 123
   * randNum( 999 ) // 1123
   * randNum( 100, 105 ) // 103
   * @returns {number}
   * @memberof __Number
   */
function randNum(minNum, maxNum) {
  var min = castNum(minNum);
  var max = castNum(maxNum, MAX_SAFE_INTEGER);
  return Math.round((max - min) * Math.random()) + min;
}






function _decimalAdjust(type, value, exponent) {
  if (exponent === 0) {
    return Math[type](value);
  }
  var exp = exponent;
  var val = value;

  if (exp % 1 !== 0) return NaN;

  var v = val.toString().split('e');
  val = Math[type](+(v[0] + "e" + (v[1] ? +v[1] - exp : -exp)));

  v = val.toString().split('e');
  return +(v[0] + "e" + (v[1] ? +v[1] + exp : exp));
}


/**
   * roundNum
   *
   * @param {number} value
   * @param {number} exp
   * @example
   * roundNum(55.55, -1) // 55.6
   * roundNum(55.549, -2) // 55.55
   * roundNum(55.4, 1) // 60
   * @returns {number}
   * @memberof __Number
   */
function roundNum(value, exp) {
  return _decimalAdjust('round', value, exp);
}


/**
   * ceilNum
   *
   * @param {number} value
   * @param {number} exp
   * @example
   * ceilNum(55.51, -1) // 55.6
   * ceilNum(-55.59, -1) // -55.5
   * ceilNum(-59, 1) // -50
   * @returns {number}
   * @memberof __Number
   */
function ceilNum(value, exp) {
  return _decimalAdjust('ceil', value, exp);
}



/**
   * floorNum
   *
   * @param {number} value
   * @param {number} exp
   * @example
   * floorNum(55.59, -1) // 55.5
   * floorNum(-55.51, -1) // -55.6
   * floorNum(59, 1) // 50
   * @returns {number}
   * @memberof __Number
   */
function floorNum(value, exp) {
  return _decimalAdjust('floor', value, exp);
}



/**
   * Округляет число и заменяет три степени буквами `K` *
   *
   * @param {number} value
   * @example
   * shortenNum(137100100) // 137KK
   * shortenNum(13710010) // 14KK
   * shortenNum(1371001 // 1KK
   * shortenNum(137100 // 137KK
   * @returns {string}
   * @memberof __Number
   */
function shortenNum(value) {
  var num = parseInt(value);
  if (Number.isNaN(num)) return '';


  var str = "" + num;var _str =
  str,length = _str.length;
  var count = parseInt(length / 3);
  if (length % 3 === 0 && count !== 0) {
    count--;
  }

  // eslint-disable-next-line no-restricted-properties
  str = roundNum(num / Math.pow(10, count * 3), 0).toString();
  while (count) {
    str += 'K';
    count--;
  }

  return str;
}




/**
   * Возвращает разряд числа
   *
   * @param {number} num
   * @example
   * getDigitLevel( 123 ) // 3
   * getDigitLevel( 0.03 ) // -2
   * @returns {number}
   * @memberof __Number
   */
function getDigitLevel(num) {
  var n = Math.abs(num);

  var lev = 0;

  if (n < 1) {
    while (n < Math.pow(10, lev)) {
      lev--;
    }
  } else {
    while (n >= Math.pow(10, lev)) {
      lev++;
    }
  }

  return lev;
}

// TODO: description
var splitNumRegex = /\B(?=(\d{3})+(?!\d))/g;
function splitNumByClasses(num) {
  return num.toString().replace(splitNumRegex, ' ');
}


//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/num.js
// module id = 108
// module chunks = 0